import React from 'react'
import PropTypes from 'prop-types'

const TextTwoLines = ({ text, icon, id = '' }) => {
  const MAX_CHARS_PER_LINE = 15
  if (text !== undefined && text !== '') {
    let textLength = text.length
    let firstLine =
      text.length > MAX_CHARS_PER_LINE
        ? text.substring(0, Math.round(textLength / 2))
        : text
    let secondLine =
      text.length > MAX_CHARS_PER_LINE
        ? text.substring(Math.round(textLength / 2), textLength)
        : ''
    return (
      <div className="dev_dash__api_credentials_align_elements">
        <div className="dev_dash__api_credentials_two_lines_space" id={id}>
          {firstLine}
          <br />
          {secondLine}
        </div>
        <div className="dev_dash__api_credentials_align_elements dev_dash__api_credentials_icon_container">
          {icon}
        </div>
      </div>
    )
  }
  return null
}

TextTwoLines.propTypes = {
  text: PropTypes.string,
  icon: PropTypes.object,
}

export default TextTwoLines
